<template>
  <div
    v-if="timerActive"
    class="timer-container"
    :class="{ 'timer-active': timerActive }" 
  >
    <div class="timer-container__heading">
      <p class="fs-12 text-KQ-White text--bold">{{ label }}</p>
    </div>
    <div class="timer-container__timer">
      <div class="timer-container__timer-days">
        <span
          ><p class="m-b--0 text-KQ-White text--bold">{{ days }}</p></span
        ><span class="fs-10 text-KQ-Grey5">DAY</span>
      </div>
      <span class="colon text-KQ-White">:</span>
      <div class="timer-container__timer-hours">
        <span
          ><p class="m-b--0 text-KQ-White text--bold">{{ hours }}</p></span
        ><span class="fs-10 text-KQ-Grey5">HRS</span>
      </div>
      <span class="colon text-KQ-White">:</span>
      <div class="timer-container__timer-minutes">
        <span
          ><p class="m-b--0 text-KQ-White text--bold">{{ minutes }}</p></span
        ><span class="fs-10 text-KQ-Grey5">MIN</span>
      </div>
      <span class="colon text-KQ-White">:</span>
      <div class="timer-container__timer-seconds">
        <span
          ><p class="m-b--0 text-KQ-White text--bold">{{ seconds }}</p></span
        ><span class="fs-10 text-KQ-Grey5">SEC</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    startYear: {
      type: String,
      required: false,
      default: '0000'
    },
    startMonth: {
      type: String,
      required: false,
      default: '00'
    },
    startDay: {
      type: String,
      required: false,
      default: '00'
    },
    startHour: {
      type: String,
      required: false,
      default: '00'
    },
    startMinute: {
      type: String,
      required: false,
      default: '00'
    },
    startSecond: {
      type: String,
      required: false,
      default: '00'
    },
    endYear: {
      type: String,
      required: true,
      default: '0000'
    },
    endMonth: {
      type: String,
      required: true,
      default: '00'
    },
    endDay: {
      type: String,
      required: true,
      default: '00'
    },
    endHour: {
      type: String,
      required: true,
      default: '00'
    },
    endMinute: {
      type: String,
      required: true,
      default: '00'
    },
    endSecond: {
      type: String,
      required: true,
      default: '00'
    },
    label: {
      type: String,
      default: "Offer ends in"
    }
  },
  data() {
    return {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00',
      timerActive: false,
    };
  },
  mounted() {

 
    const startDateTime = new Date(`${this.startYear}-${this.startMonth}-${this.startDay}T${this.startHour}:${this.startMinute}:${this.startSecond}`);
    const endDateTime = new Date(`${this.endYear}-${this.endMonth}-${this.endDay}T${this.endHour}:${this.endMinute}:${this.endSecond}`);
    const hasStarted = startDateTime.getTime() < new Date().getTime();
    const hasEnded = endDateTime.getTime() < new Date().getTime();

    if (hasEnded) {
      return;
    }

    if (startDateTime.getTime() > endDateTime.getTime()) {
      console.error('Start date is after end date');
      return;
    }

    const startInMilliseconds = startDateTime.getTime() - new Date().getTime();
    if (hasStarted) {
      this.startTimer();
    }

    setTimeout(() => {
      this.startTimer();
    }, startInMilliseconds);
  },
  methods: {
    startTimer() {
      this.timerActive = true;
      const endDateTime = new Date(`${this.endYear}-${this.endMonth}-${this.endDay}T${this.endHour}:${this.endMinute}:${this.endSecond}`);

      const countDown = setInterval(() => {
        const now = new Date().getTime();
        const distance = endDateTime - now;

        if (distance <= 0) {
          clearInterval(countDown);
          this.timerActive = false;
        } else {
          this.days = Math.floor(distance / (1000 * 60 * 60 * 24))
            .toString()
            .padStart(2, '0');
          this.hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          )
            .toString()
            .padStart(2, '0');
          this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
            .toString()
            .padStart(2, '0');
          this.seconds = Math.floor((distance % (1000 * 60)) / 1000)
            .toString()
            .padStart(2, '0');
        }
      }, 1000);
    },
  },
};
</script>
